<script setup>
    import { ref, onMounted, onBeforeUnmount, watch } from 'vue'

    const props = defineProps({
        show: Boolean,
        title: {
            type: String,
            default: '\u00A0'
        }
    })
    const emits = defineEmits(['close'])

    const position = ref({ x: 0, y: 0 })
    const dragging = ref(false)
    const offset = ref({ x: 0, y: 0 })

    const dialog = ref(null)

    // Add user-select disabling for smoother drag and move drag handle to header
    const startDrag = (e) => {
        dragging.value = true
        offset.value = {
            x: e.clientX - position.value.x,
            y: e.clientY - position.value.y,
        }
        document.body.style.userSelect = 'none'
        document.addEventListener('mousemove', onDrag)
        document.addEventListener('mouseup', stopDrag)
    }

    const onDrag = (e) => {
        if (dragging.value) {
            position.value.x = e.clientX - offset.value.x
            position.value.y = e.clientY - offset.value.y
        }
    }

    const stopDrag = () => {
        dragging.value = false
        document.body.style.userSelect = ''
        document.removeEventListener('mousemove', onDrag)
        document.removeEventListener('mouseup', stopDrag)
    }

    const close = () => {
        emits('close')
    }

    watch(() => props.show, (val) => {
        if (val) {
            position.value = { x: window.innerWidth / 2 - 150, y: window.innerHeight / 2 - 100 }
        }
    })

    onBeforeUnmount(() => {
        document.removeEventListener('mousemove', onDrag)
        document.removeEventListener('mouseup', stopDrag)
    })
</script>

<template>
    <div
        v-if="show"
        class="fixed inset-0 z-50 flex items-center justify-center pointer-events-none"
    >
        <div
            ref="dialog"
            class="bg-white rounded shadow-lg pb-6 min-w-[300px] max-w-[90vw] relative pointer-events-auto"
            :style="{ top: `${position.y}px`, left: `${position.x}px`, position: 'absolute' }"
        >
            <div
                class="cursor-move bg-lifeworx-blue-700 px-4 py-2 rounded-t relative"
                @mousedown="startDrag"
            >
                <span class="text-white">{{ props.title }}</span>
                <button class="text-white absolute top-2 right-2" @click="close">✕</button>
            </div>
            <slot />
        </div>
    </div>
</template>
